import { render } from "./Subgrupos.page.vue?vue&type=template&id=fea2329a&ts=true"
import script from "./Subgrupos.page.vue?vue&type=script&lang=ts"
export * from "./Subgrupos.page.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\anc-transparencia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__